import zhCN from "element-ui/src/locale/lang/zh-CN";
import zh from './zh'
import enGB from 'element-ui/src/locale/lang/en'
import en from './en'


const localeMessage = {
  zh: {
    ...zhCN,
      ...zh,
  },
  en: {
    ...enGB,
      ...en
  }
};

export default localeMessage
